class Faq {
  constructor(container) {
    this.container = container;
    this.classNames = {
      questionContainerHidden: 'faq-question-container--hide'
    };
    this.searchInput = this.container.querySelector('.faq-search__input');
    this.performSearch = this.performSearch.bind(this);
    this.init();
  }

  init() {
    if (this.searchInput) {
      ['change', 'keyup', 'paste'].forEach(evt =>
        this.searchInput.addEventListener(evt, this.performSearch)
      );
    }
  }

  performSearch() {
    // Defer to avoid input lag
    setTimeout(() => {
      const terms = this.searchInput.value
        .split(' ')
        .filter(Boolean)
        .map(t => t.toLowerCase());
      console.log('faq search terms: ', terms);

      const questionContainers = this.container.querySelectorAll('.faq-question-container');

      questionContainers.forEach(element => {
        console.log('faq question container: ', element.textContent.toLowerCase());
        console.log('faq question: ', terms.length);
        if (terms.length) {
          const matchContent = element.textContent.toLowerCase();
          const termFound = terms.some(term => matchContent.includes(term));
          element.classList.toggle(
            this.classNames.questionContainerHidden,
            !termFound
          );
        } else {
          element.classList.remove(this.classNames.questionContainerHidden);
        }
      });

      // Hide non-question content while searching (using correct class name)
      this.container.querySelectorAll('.faq__category').forEach(function (element) {
        if (terms.length) {
          element.classList.add(this.classNames.questionContainerHidden);
        } else {
          element.classList.remove(this.classNames.questionContainerHidden);
        }
      }.bind(this));
    }, 10);
  }
}

// Initialize FAQ sections when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const faqSections = document.querySelectorAll('.section--faq[data-section-type="faq"]');
  faqSections.forEach(section => new Faq(section));
});

// Also initialize if script loads after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    const faqSections = document.querySelectorAll('.section--faq[data-section-type="faq"]');
    faqSections.forEach(section => new Faq(section));
  });
} else {
  const faqSections = document.querySelectorAll('.section--faq[data-section-type="faq"]');
  faqSections.forEach(section => new Faq(section));
}
